/**
 * Reason for deletion.
 * tag: 285
 * @readonly
 * @enum {string} (char)
 */
export enum DeleteReason {
  /** Cancellation / Trade Bust */
  Cancellation = '0',
  /** Error */
  Error = '1',
}
